import { Tooltip } from 'antd';
import React from 'react';
import { sourceIcon } from '../constants/documents.constants';
import styles from './table.module.scss';

const ExpandedRowDocSource = ({ record }) => {
  return (
    <Tooltip
      title={record.sourceName}
      placement="right"
    >
      {sourceIcon(record.sourceId, 18) && (
        <div className={styles.iconCover}>
          {sourceIcon(record.sourceId, 18)}
        </div>
      )}
    </Tooltip>
  );
};

export default ExpandedRowDocSource;
